import cn from 'classnames'

import { Translation } from 'cng-common/features/translations'

import { FINANCIAL_COCKPIT_TRANSLATION_KEYS } from '../../../../configs/translations'
import type { IPendingPbmReplacement } from '../../../../lib'

import styles from './AttentionPbmReplacement.module.scss'

const KEYS = FINANCIAL_COCKPIT_TRANSLATION_KEYS.attentionStatuses.replacement

interface IAttentionPbmNameProps {
  name: string
  pending?: IPendingPbmReplacement
  className?: string
}

/** A PBM's name, and while their replacement waits for approval, who takes over and that it waits. */
export const AttentionPbmName = ({ name, pending, className }: IAttentionPbmNameProps) => (
  <span className={cn(styles.name, className)}>
    <span className={styles.nameText}>
      {name}
      {pending?.toName && (
        <>
          <span className={styles.arrow} aria-hidden="true">
            →
          </span>
          {pending.toName}
        </>
      )}
    </span>
    {pending && (
      <span className={styles.pending}>
        <Translation span text={KEYS.pending} />
      </span>
    )}
  </span>
)

AttentionPbmName.displayName = 'AttentionPbmName'
